import { InjectionToken, TypeProvider } from '@angular/core';
import { Translation, TranslocoConfig } from '@ngneat/transloco';
import { Observable } from 'rxjs';

export const SCOPE_REGISTRY = new InjectionToken<ScopeRegistryType>(
  'Scope Registry'
);

export const RESOLVER_REGISTRY = new InjectionToken<ResolverConfig>(
  'Source Loader Resolver'
);

export type SourceConfig = { resolvers?: ResolverConfig[] };

export type i18nConfig = Partial<TranslocoConfig> & SourceConfig;

export interface ScopeConfig {
  scope: string;
  alias?: string;
  resolver?: string;
}

export interface ScopeRegistryType {
  scope: string;
  resolver: string;
}

export interface ResolverConfig {
  key: string;
  resolver: TypeProvider;
}

export interface Resolver {
  load(lang: string, scope?: string): Observable<Translation>;
}
